import api from '../api'

export const dadosSuporteService = {

    postComFiltro: (filtros: any, tabela: any) => {
        return api.post(`${tabela}/PostComFiltros`, filtros)
            .then((response: any) => {
                return response.data
            });
    },

    post: (dadoSuporte: any, tabela: any) => {
        return api.post(`${tabela}/dadosSuporte`, dadoSuporte)
            .then((response: any) => { return response.data });
    },

    put: (dadosSuporte: any, tabela: any) => {
        return api.put(`${tabela}/dadosSuporte`, dadosSuporte)
            .then((response: any) => { return response.data });
    },

    getPropertiesByTabela: (tabela: string) => {
        return api.get(`${tabela}/getpropertiesbytabela`)
            .then((response: any) => { return response.data });
    }
}